import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  oldLoginScreenUrl: string = environment.LoginScreen.replace(
    '/Account/LogOff',
    ''
  );

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToNewUI(): void {
    this.router.navigate(['/login']);
  }

  navigateToOldUI(): void {
    window.location.href = this.oldLoginScreenUrl;
  }
}
